/**
 * 내 신고에 **새 답**이 왔는지 — 도움말 › 문제 신고 옆 숫자 (QBase 운영 감시 VOC, 2026-09-23).
 *
 * 답은 QBase 운영 감시(AI 분류 · 담당자)가 쓰고, 백엔드가 1분마다 받아 신고에 붙인다. 여기서는 그 결과만 센다.
 * 관리자 알림(useOpsLogAlerts)과 달리 **로그인한 모든 사용자**가 대상이다 — 자기 신고의 답이다.
 * "내 신고" 를 열면(`markFeedbackSeen`) 곧바로 0.
 */
import { useEffect, useState } from 'react';
import { fetchFeedbackUnseen, FEEDBACK_SEEN_EVENT } from '../services/opsLog';

/** 묻는 주기 — 답은 사람이 쓰므로 몇 분 늦어도 된다 */
const POLL_MS = 2 * 60 * 1000;

export default function useFeedbackReplies(active) {
    const [n, setN] = useState(0);

    useEffect(() => {
        if (!active) {
            setN(0);
            return undefined;
        }
        let alive = true;
        let timer = null;
        const tick = async () => {
            try {
                const r = await fetchFeedbackUnseen();
                if (alive) setN((r && r.n) || 0);
            } catch (_e) { /* 실패는 조용히 다음 주기에 */ }
            if (alive) timer = setTimeout(tick, POLL_MS);
        };
        const onSeen = () => setN(0);
        window.addEventListener(FEEDBACK_SEEN_EVENT, onSeen);
        tick();
        return () => {
            alive = false;
            clearTimeout(timer);
            window.removeEventListener(FEEDBACK_SEEN_EVENT, onSeen);
        };
    }, [active]);

    return n;
}
